export default __webpack_public_path__ + "static/media/Venturer's Legguards of Stalking Fury.4d28d7f4.jpg";